import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Logout } from "store/actions/AuthActions";

const Sidebar = () =>{
const navigate = useNavigate();

const userDetails = JSON.parse(localStorage.getItem("userDetails") || "{}");
const permissions = userDetails.userdata.permissions ? JSON.parse(userDetails.userdata.permissions) : [];

const isAdmin = userDetails.userdata?.is_admin === 1; // <- Important: checking admin!

  const hasPermission = (permission) => {
    return isAdmin || permissions.includes(permission);
  };

  const onLogout =()=> {
    localStorage.removeItem("userDetails");
    navigate("/");
    // dispatch(Logout(navigate));
  }
  
 return (
  <aside className="main-sidebar">
      {/* Sidebar */}
      <div className="sidebar">
        {/* Sidebar menu */}
        <ul className="sidebar-menu">
          <li className="active">
            <Link to="/dashboard">
              <i className="fa fa-tachometer" />
              <span>Dashboard</span>
            </Link>
          </li>

          {/* Manage User */}
          {(hasPermission("Add Users") || hasPermission("View Users")) && (
          <li className="treeview">
            <a href="#">
              <i className="fa fa-user" />
              <span>Manage User</span>
              <i className="fa fa-angle-left float-right pull-right-container" />
            </a>
            <ul className="treeview-menu">
            {hasPermission("Add Users") && <li><Link to="add-user">Add User</Link></li>}
            {hasPermission("View Users") && <li><Link to="users">View User</Link></li>}
            </ul>
          </li>
        )}
          {/* Manage Hotels */}
          {(hasPermission("Add Hotel") || hasPermission("View Hotel")) && (
          <li className="treeview">
            <a href="#">
              <i className="fa fa-building" />
              <span>Manage Hotels</span>
              <i className="fa fa-angle-left float-right pull-right-container" />
            </a>
            <ul className="treeview-menu">
            {hasPermission("Add Hotel") && <li><Link to="add-hotel">Add New Hotel</Link></li>}
            {hasPermission("View Hotel") && <li><Link to="hotels">View Hotels</Link></li>}
            </ul>
          </li>
         )}
          {/* Manage Agents */}
          {(hasPermission("Add Agent") || hasPermission("View Agent")) && (
          <li className="treeview">
            <a href="#">
              <i className="fa fa-user" />
              <span>Manage Agents</span>
              <i className="fa fa-angle-left float-right pull-right-container" />
            </a>
            <ul className="treeview-menu">
            {hasPermission("Add Agent") && <li><Link to="add-agent">Add Agent</Link></li>}
            {hasPermission("View Agent") && <li><Link to="agents">View Agent</Link></li>}
            </ul>
          </li>
         )}
          {/* Manage Booking */}
          {(hasPermission("Add Booking") || hasPermission("View Booking")) && (
          <li className="treeview">
            <a href="#">
              <i className="fa fa-hotel" />
              <span>Manage Booking</span>
              <i className="fa fa-angle-left float-right pull-right-container" />
            </a>
            <ul className="treeview-menu">
              {hasPermission("Add Booking") && <li><Link to="add-booking">New Booking</Link></li>}
              {hasPermission("View Booking") && <li><Link to="bookings">View Booking</Link></li>}
            </ul>
          </li>
           )}
          {/* Manage Billing */}
          {(hasPermission("Add Billing") || hasPermission("View Billing")) && (
          <li className="treeview">
            <a href="#">
              <i className="fa fa-file-text-o" />
              <span>Manage Billing</span>
              <i className="fa fa-angle-left float-right pull-right-container" />
            </a>
            <ul className="treeview-menu">            
              {hasPermission("Add Billing") && <li><Link to="add-billing">New Billing</Link></li>}
              {hasPermission("View Billing") && <li><Link to="billings">View Billing</Link></li>}
            </ul>
          </li>
          )}
          {/* Room Category */}
          {(hasPermission("Add Room Category") || hasPermission("View Room Category")) && (
          <li className="treeview">
            <a href="#">
              <i className="fa fa-hotel" />
              <span>Room Category</span>
              <i className="fa fa-angle-left float-right pull-right-container" />
            </a>
            <ul className="treeview-menu">
              {hasPermission("Add Room Category") &&  <li><Link to="/add-room-category">Add Room Category</Link></li>}
              {hasPermission("View Room Category") &&   <li><Link to="/room-categories">View Room Category</Link></li>}
            </ul>
          </li>
           )}
           {/* City */}
           {(hasPermission("Add City") || hasPermission("View City")) && (
           <li className="treeview">
            <a href="#">
              <i className="fa fa-hotel" />
              <span>City</span>
              <i className="fa fa-angle-left float-right pull-right-container" />
            </a>
            <ul className="treeview-menu">
            {hasPermission("Add City") &&   <li><Link to="/add-city">Add City</Link></li> }
            {hasPermission("View City") &&    <li><Link to="/cities">View City</Link></li> }
            </ul>
          </li>
          )}
          {/* Room Type */}
          {(hasPermission("Add Room Type") || hasPermission("View Room Type")) && (
          <li className="treeview">
            <a href="#">
              <i className="fa fa-hotel" />
              <span>Room Type</span>
              <i className="fa fa-angle-left float-right pull-right-container" />
            </a>
            <ul className="treeview-menu">
            {hasPermission("Add Room Type") &&   <li><Link to="/add-room-type">Add Room Type</Link></li>}
             {hasPermission("View Room Type") &&   <li><Link to="/room-types">View Room Type</Link></li>}
            </ul>
          </li>
          )}
          {/* Logout */}
          <li className="treeview">
            <a
              type="button"
              data-toggle="modal"
              data-target="#logout"
              className="log-out"
              href="#"
              onClick={onLogout}
            >
              <i className="fa fa-sign-out" />
              <span>Logout</span>
            </a>
          </li>
        </ul>
      </div>
    </aside>
)};

export default Sidebar;
